//Componentes generales
import React from "react";

// Iconos
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faBox
} from "@fortawesome/free-solid-svg-icons";

    const RenderRow = ({ index, style, subcuentas = [], filter }) => {
            if (filter === '') {
                return (
                    <div style={style} className='container-p-list'>
                        <li>
                            <div className='container-p-list-item'>
                                <div className="container-p-list-item-horizontal">
                                    <div className='list-item-icon-p'><FontAwesomeIcon icon={faBox} /></div>
                                    <div className="label-title-products">Dimensión: <div className="label-products">{subcuentas[index].codDim} - {subcuentas[index].codDimDescrp}</div></div>
                                    <div className="label-title-products">Código Subcuenta: <div className="label-products">{subcuentas[index].subCue}</div> </div>
                                    <div className="label-title-products">Descripción: <div className="label-products">{subcuentas[index].subCueDescrp}</div></div>
                                </div>
                            </div>
                        </li>
                    </div>);
            }else{
                const subcuentas_filters = subcuentas.filter(s => s.codDim.toLowerCase().includes(filter.toLowerCase()) || s.codDimDescrp.toLowerCase().includes(filter.toLowerCase()) || s.subCue.toLowerCase().includes(filter.toLowerCase()) || s.subCueDescrp.toLowerCase().includes(filter.toLowerCase()));
                return (
                    <div style={style} className='container-p-list'>
                        <li>
                            <div className='container-p-list-item'>
                                <div className="container-p-list-item-horizontal">
                                    <div className='list-item-icon-p'><FontAwesomeIcon icon={faBox} /></div>
                                    <div className="label-title-products">Dimensión: <div className="label-products">{subcuentas_filters[index].codDim} - {subcuentas_filters[index].codDimDescrp}</div></div>
                                    <div className="label-title-products">Código Subcuenta: <div className="label-products">{subcuentas_filters[index].subCue}</div> </div>
                                    <div className="label-title-products">Descripción: <div className="label-products">{subcuentas_filters[index].subCueDescrp}</div></div>
                                </div>
                            </div>
                        </li>
                    </div>);
            }
};

export default RenderRow